import { FETCH_RESERVE_START,FETCH_RESERVE_SUCCESS, FETCH_RESERVE_ERROR, ADD_UPDATE_RESERVE_EVENT_START, ADD_UPDATE_RESERVE_EVENT_SUCCESS, ADD_UPDATE_RESERVE_EVENT_ERROR } from '../actions/reserveActions';

const INIT_STATE = {
  loading: false,
  submitting: false,
  machines: [],
  users: [],
  events: [],
};

const reserveReducer = (state = INIT_STATE, action) => {
  let newEvents;
  switch (action.type) {
      case FETCH_RESERVE_START: {
          return { ...state, loading: true };
      }
      case FETCH_RESERVE_SUCCESS: {
          return { ...state, loading: false, events: action.events };
      }
      case FETCH_RESERVE_ERROR: {
          return { ...state, loading: false };
      }
      case ADD_UPDATE_RESERVE_EVENT_SUCCESS: {
          newEvents = [...state.events];
          const index = newEvents.findIndex(evt => evt.reservationId === action.event.reservationId);
          if (index > -1) {
              newEvents.splice(index, 1, { ...newEvents[index], ...action.event });
          } else {
              newEvents.push(action.event);
          }
          return { ...state, submitting: false, events: [...newEvents] };
      }
      case ADD_UPDATE_RESERVE_EVENT_ERROR: {
        return { ...state, loading: false };
    }
      default:
          return state;
  }
}

export default reserveReducer;